import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const OverallJourneyAnalyticsMainContainer = lazy(
  () =>
    import(
      "../components/OverallJourneyAnalyticsMainContainer/OverallJourneyAnalyticsMainContainer"
    )
);

const OverallJourneyAnalyticsRoutes: RouteObject = {
  path: "journeys/analytics",
  element: <OverallJourneyAnalyticsMainContainer />,
};

export default OverallJourneyAnalyticsRoutes;
